import React, { useCallback, useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import { Form, InputGroup, Table } from "react-bootstrap";
import CustomPagination from "../../components/CustomPagination";
import SubscriptionView from "../../components/subscription/SubscriptionView";
import NoDateFound from "../../components/NoDateFound";
import Loader from "../../components/loader/Loader";
import { useGlobalState } from "../../context/GlobalStateContext";
import axiosInstance from "../../utils/axiosConfig";
import * as CustomToast from "../../components/CustomToastMessage";

function Subscription() {
  const [subscriptions, setSubscriptions] = useState([]);
  const {
    loading,
    setLoading,
    search,
    pagination,
    setPagination,
    handleSearch,
    handleLimitChange,
  } = useGlobalState();

  const fetchSubscriptions = useCallback(
    async (page = 1, limit = 10, searchQuery = "") => {
      try {
        setLoading(true);
        const response = await axiosInstance.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/subscription/list`,
          {
            params: {
              page,
              limit,
              search: searchQuery,
            },
          }
        );
        if (response.data.success) {
          setSubscriptions(response.data.data);
          setPagination(response.data.pagination);
        } else {
          setSubscriptions([]);
          setPagination((prev) => ({
            ...prev,
            currentPage: 1,
            totalPages: 1,
            totalItems: 0,
          }));
        }
      } catch (error) {
        if (error.response.data.status === 400) {
          CustomToast.error(error.response?.data?.message);
        }
        console.error(error.response?.data?.message || "Internal server error");
        setSubscriptions([]);
        setPagination((prev) => ({
          ...prev,
          currentPage: 1,
          totalPages: 1,
          totalItems: 0,
        }));
      } finally {
        setLoading(false);
      }
    },
    [setLoading, setPagination]
  );

  useEffect(() => {
    fetchSubscriptions(pagination.currentPage, pagination.limit, search);
  }, [pagination.currentPage, pagination.limit, search, fetchSubscriptions]);

  return (
    <Layout title="Subscription List">
      <main>
        <div className="card page-card">
          <div className="card-header d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
            <div className="d-flex align-items-center gap-3">
              <p>Show</p>
              <Form.Select
                aria-label="Default select example"
                value={pagination.limit}
                onChange={handleLimitChange}
              >
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </Form.Select>
              <p>entries</p>
            </div>

            <div className="d-flex flex-column flex-md-row  align-items-start align-items-md-center gap-3 sm-w-100">
              <div className="header-search">
                <InputGroup>
                  <InputGroup.Text id="basic-addon1" className="bg-transparent">
                    <img src="/images/png/search.png" width={20} alt="" />
                  </InputGroup.Text>
                  <Form.Control
                    type="search"
                    className="border-start-0 ps-0"
                    placeholder="search here..."
                    value={search}
                    onChange={handleSearch(fetchSubscriptions)}
                  />
                </InputGroup>
              </div>
            </div>
          </div>

          <div className="card-body">
            <div className="overflow-auto">
              <Table>
                <thead>
                  <tr>
                    <th width="40">Id</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Plan Name</th>
                    <th>Promo Code</th>
                    <th>Purchase Date</th>
                    <th>Expire Date</th>
                    <th>Status</th>
                    <th width="100" className="text-center">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="7" className="text-center">
                        <Loader />
                      </td>
                    </tr>
                  ) : subscriptions.length > 0 ? (
                    subscriptions.map((item, index) => (
                      <tr key={item._id}>
                        <td>
                          <p className="mb-0">
                            {(pagination.currentPage - 1) * pagination.limit +
                              index +
                              1}
                          </p>
                        </td>
                        <td>
                          {item.userId?.firstName
                            ? item.userId?.lastName
                              ? item.userId?.firstName +
                                " " +
                                item.userId?.lastName
                              : item.userId?.firstName
                            : "-"}
                        </td>
                        <td>{item.userId?.email ? item.userId?.email : "-"}</td>
                        <td>{item.planName ? item.planName : "Basic"}</td>
                        <td>
                          {item.promoCodeId?.code
                            ? item.promoCodeId?.code
                            : "-"}
                        </td>
                        <td>
                          {item.purchaseDate
                            ? new Date(item.purchaseDate)
                                .toISOString()
                                .split("T")[0]
                            : "-"}
                        </td>
                        <td>
                          {item.expiryDate
                            ? new Date(item.expiryDate)
                                .toISOString()
                                .split("T")[0]
                            : "-"}
                        </td>
                        <td>{item.promoCodeId?.code ? 'PROMO CODE' : item.status}</td>
                        {/* <td>{item.status ? item.status : "-"}</td> */}
                        <td width="100" className="text-center">
                          <SubscriptionView subscription={item} />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="10" className="text-center">
                        <NoDateFound />
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
            <CustomPagination
              currentPage={pagination.currentPage}
              totalPages={pagination.totalPages}
              totalItems={pagination.totalItems}
              limit={pagination.limit}
              onPageChange={(page) =>
                setPagination((prev) => ({ ...prev, currentPage: page }))
              }
            />
          </div>
        </div>
      </main>
    </Layout>
  );
}

export default Subscription;
